import {
    GET_ZIP_REQUEST,
    GET_ZIP_SUCCESS,
    GET_ZIP_ERROR,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getZip = (token) => (dispatch) => {
    dispatch({ type: GET_ZIP_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/ZipCodesShipTo`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: GET_ZIP_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ZIP_ERROR,
                payload: error.response,
            });
        });
};

